import React, { useEffect, useState } from "react";
import DefaultModal from "../DefaultModal";
import ModalPaymentPhone from "./payment_details/ModalPaymentPhone";
import ModalPaymentCard from "./payment_details/ModalPaymentCard";
import { useAppSelector } from "../../../store/index.ts";
import "./top-up-balance.scss";
import { useReadLocalStorage } from "usehooks-ts";
import { ENUM_LCS_NAME } from "../../../store/enums.js";
import { dispatchCusEvent } from "../../../utils/utils.js";
import { ENUM_COMMON_EVENT } from "../../../hooks/common/useListener.js";
import useRequireVerify from "../../../hooks/useRequireVerify.js";
import DepositContent from "./deposit_content/DepositContent.jsx";

export default function TopUpBalance({ isOpen, closeModal, defaultDeposit }) {
  const { lockDep } = useRequireVerify();
  const start_r = useReadLocalStorage(ENUM_LCS_NAME.startR) || "";

  const lockBonusClose = useAppSelector((state) => state.site.lock.balanceClose);
  const isMobileSize = useAppSelector((state) => state.deviceSize.isMobileSize);

  const [openPaymentPhone, setOpenPaymentPhone] = useState(false);
  const [openPaymentCard, setOpenPaymentCard] = useState(false);

  useEffect(() => {
    if (isOpen) {
      if (lockDep) {
        dispatchCusEvent(ENUM_COMMON_EVENT.emailNotConfirmed);
        closeModal();
        return;
      }

      dispatchCusEvent(ENUM_COMMON_EVENT.checkCaptcha);
    }
  }, [isOpen, start_r]);

  return (
    <>
      <DefaultModal
        isOpen={isOpen}
        classModal="top-up-balance"
        closeModal={!lockBonusClose && closeModal}
        hideClose={lockBonusClose}
        largeModal={!isMobileSize}
        miniModal={isMobileSize}>
        <DepositContent
          defaultDeposit={defaultDeposit}
          isOpen={isOpen}
          closeModal={closeModal}
          setOpenPaymentCard={setOpenPaymentCard}
          setOpenPaymentPhone={setOpenPaymentCard}
        />
      </DefaultModal>

      <ModalPaymentPhone
        isOpen={!!openPaymentPhone}
        closeModal={() => {
          setOpenPaymentPhone(false);
          closeModal();
        }}
        data={openPaymentPhone}
      />

      <ModalPaymentCard
        isOpen={!!openPaymentCard}
        data={openPaymentCard}
        closeModal={() => {
          setOpenPaymentCard(false);
          closeModal();
        }}
      />
    </>
  );
}
